<template>
  <v-dialog v-model="loadApprovalPinForm" no-click-animation persistent max-width="400">
    <v-card>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-title class="headline primary white--text">{{ dialogTitle }}</v-card-title>
        <v-card-text class="mt-20">
          <dynamic-form
            :watchKey="loadApprovalPinForm"
            :fieldGroups="loadApprovalPinFields"
            :bindObj="loadApprovalPin"
            :events="{ generatePIN }"
            :split="false"
          />
          <div class="red--text font-weight-bold ma-2">
            "NOTE" any previous PIN or PIN submits for this Sales Order taken by a forkdrivers will
            be removed
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="discard" class="white--text" color="primary" small depressed>
            Discard
          </v-btn>
          <v-btn
            @click="doSave"
            class="white--text"
            color="primary"
            :disabled="invalid || processing"
            small
            depressed
          >
            Save
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import loadApprovalPinFields from '@/models/load-approval-pin-form';
import _ from 'lodash';
import { randomPin } from '@/utils';

export default {
  name: 'LoadApprovalPinForm',
  data() {
    return { oldLoadApprovalPin: {}, processing: false };
  },
  computed: {
    ...mapState('loadApproval', ['operation', 'generatedPassword']),
    loadApprovalPinFields() {
      return loadApprovalPinFields;
    },
    loadApprovalPinForm: {
      get: () => store.state.loadApproval.loadApprovalPinForm,
      set: v => store.commit('loadApproval/setLoadApprovalPinForm', v)
    },
    loadApprovalPin: {
      get() {
        const { loadApprovalPin } = store.state.loadApproval;
        if (this.operation === 'create') return loadApprovalPin;
        return _.cloneDeep(loadApprovalPin);
      },
      set: v => store.commit('loadApproval/setLoadApprovalPin', v)
    },
    dialogTitle() {
      if (this.operation === 'create') return 'Create a New PIN';
      return `Update PIN`;
    }
  },
  methods: {
    ...mapMutations('loadApproval', ['toggleLoadApprovalPinForm']),
    ...mapActions('loadApproval', ['createLoadApprovalPin', 'updateLoadApprovalPin']),
    async doSave() {
      const { operation, loadApprovalPin } = this;
      this.processing = true;
      if (operation === 'create') {
        await this.createLoadApprovalPin(loadApprovalPin);
      } else {
        await this.updateLoadApprovalPin(loadApprovalPin);
      }
      this.processing = false;
      this.$refs.observer.reset();
      this.oldLoadApprovalPin = _.cloneDeep(this.loadApprovalPin);
      this.toggleLoadApprovalPinForm();
    },
    discard() {
      this.toggleLoadApprovalPinForm();
      this.loadApprovalPin = _.cloneDeep(this.oldLoadApprovalPin);
      this.$refs.observer.reset();
    },
    generatePIN() {
      this.loadApprovalPin.pin = randomPin();
    }
  },
  watch: {
    async loadApprovalPinForm(n) {
      if (n) this.oldLoadApprovalPin = _.cloneDeep(this.loadApprovalPin);
    }
  }
};
</script>
